import { theme } from "@upsolve/ui";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}template{display:none}[hidden]{display:none}
  @font-face {
    font-display: swap;
    font-family: 'Averta';
    src: url("https://static.upsolve.org/fonts/averta-light.woff2") format('woff2');
    font-weight: 200;
    font-style: normal;
  }
  @font-face {
    font-display: swap;
    font-family: 'Averta';
    src: url("https://static.upsolve.org/fonts/averta-regular.woff2") format('woff2');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-display: swap;
    font-family: 'Averta';
    src: url("https://static.upsolve.org/fonts/averta-semibold.woff2") format('woff2');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Castoro';
    src: url("https://s3.amazonaws.com/static.upsolve.org/fonts/Castoro-Regular.ttf") format('ttf');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
  * {
    box-sizing: border-box;
  }
  html {
    color: ${theme.colors.gray["500"]};
    background-color: ${theme.colors.white["900"]};
    line-height: 150%;
    font-size: 1em;
    font-family: 'Averta', sans-serif;
    font-weight: 300;
  }
  body {
    margin: 0;
   
  }
  .noscroll{
      overflow:hidden;
  }
  a, button {
    font-family: 'Averta', sans-serif;
  }
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }
  ul {
    list-style-type: none;
  }
  ul, ol {
    padding: 0;
  }
  a {
    text-decoration: none;
  }
  .hide-sm {
    @media(max-width: 45em) {
      display: none;
    }
  }
  .hide-xs {
    @media(max-width: 25em) {
      display: none;
    }
  }
  .show-sm {
    display: none;
    @media(max-width: 45em) {
      display: initial;
    }
  }
  h1, h2, h3, h4, h5, h6 {
    scroll-margin-top: calc(var(--nav-header-height) + 8px);
  }
  html[data-hello-bar-closed="true"] .hellobar-container {
    display: none;
  }
`;

export default GlobalStyle;
